"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAddToBag = void 0;
var AddPersonalSubscriptionEvent = _interopRequireWildcard(require("@ori-events/add-personal-subscription"));
var AddPersonalSubscriptionFailedEvent = _interopRequireWildcard(require("@ori-events/add-personal-subscription-failed"));
var AddToBasketEvent = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var AddToBasketFailedEvent = _interopRequireWildcard(require("@ori-events/add-to-basket-failed"));
var BasketUpdatedEvent = _interopRequireWildcard(require("@ori-events/basket-updated"));
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _types = require("./types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const useAddToBag = ({
  analyticsData,
  itemCode,
  lineNumber,
  originalQuantity,
  subscriptionPlacement
}) => {
  const resolveRef = (0, _react.useRef)(null);
  const startSubmitting = (0, _react.useCallback)(async () => {
    await new Promise(resolve => {
      resolveRef.current = resolve;
    });
  }, []);
  // istanbul ignore next @preserve --No need to test waiting for promise to resolve
  const stopSubmitting = (0, _react.useCallback)(() => {
    if (resolveRef.current) {
      resolveRef.current('success');
    }
  }, []);
  const eventHandlers = (0, _react.useMemo)(() => [{
    name: AddToBasketFailedEvent.Name,
    listener: stopSubmitting
  }, {
    name: BasketUpdatedEvent.Name,
    listener: stopSubmitting
  }, {
    name: AddPersonalSubscriptionFailedEvent.Name,
    listener: stopSubmitting
  }], [stopSubmitting]);
  (0, _presentationHooks.useGlobalEvents)(eventHandlers);
  const onAddToBag = (0, _react.useCallback)(async ({
    frequency,
    mode,
    quantity
  }) => {
    if (mode === _types.SubscriptionModuleMode.Subscribe) {
      window.dispatchEvent(new CustomEvent(AddPersonalSubscriptionEvent.Name, {
        detail: {
          itemCode,
          frequency,
          placement: subscriptionPlacement ?? analyticsData.placement,
          lineNumber,
          originalQuantity
        }
      }));
    } else {
      window.dispatchEvent(new CustomEvent(AddToBasketEvent.Name, {
        detail: {
          ...analyticsData,
          itemCode,
          quantity
        }
      }));
    }
    await startSubmitting();
  }, [analyticsData, itemCode, lineNumber, originalQuantity, startSubmitting, subscriptionPlacement]);
  return {
    onAddToBag
  };
};
exports.useAddToBag = useAddToBag;
//# sourceMappingURL=hooks.js.map